import { REDEEM_GIFT_CARD, CLEAR_REDEEMED_GIFT_CARDS } from 'actions/actionConstants'
import { RedeemedCard } from 'components/Common/RedeemGiftCard/common'

export interface RedeemedGiftCardsState {
  cards: Array<RedeemedCard>
}

export const initialRedeemedGiftCardsState: RedeemedGiftCardsState = {
  cards: [],
}

export default function redeemedGiftCardsReducer(
  state: RedeemedGiftCardsState = initialRedeemedGiftCardsState,
  action: any,
): RedeemedGiftCardsState {
  switch (action.type) {
    case REDEEM_GIFT_CARD:
      return {
        ...state,
        cards: [...state.cards, action.card],
      }
    case CLEAR_REDEEMED_GIFT_CARDS:
      return {
        ...state,
        cards: [],
      }
    default:
      return state
  }
}
